import { Button } from '@/modules/shared/components/ui/button'
import { DateTimePicker } from '@/modules/shared/components/ui/datetime-picker'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/modules/shared/components/ui/dialog'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
} from '@/modules/shared/components/ui/form'
import { Textarea } from '@/modules/shared/components/ui/textarea'

import { useModalSchedulerComponent } from './use-modal-schedule.hook'

export function ModalScheduleComponent() {
	const {
		handleSaveSchedule,
		handleCancelSchedule,
		isOpenModalSchedule,
		form,
	} = useModalSchedulerComponent()

	return (
		<Dialog open={isOpenModalSchedule} onOpenChange={handleCancelSchedule}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Agendamento</DialogTitle>
				</DialogHeader>

				<Form {...form}>
					<form onSubmit={form.handleSubmit(handleSaveSchedule)}>
						<FormField
							control={form.control}
							name="data"
							render={({ field }) => (
								<FormItem>
									<FormLabel>Data</FormLabel>
									<FormControl>
										<DateTimePicker
											date={field.value}
											setDate={field.onChange}
										/>
									</FormControl>
								</FormItem>
							)}
						/>
						<FormField
							control={form.control}
							name="observacao"
							render={({ field }) => (
								<FormItem>
									<FormLabel>Observação</FormLabel>
									<FormControl>
										<Textarea
											{...field}
											spellCheck={false}
											placeholder="Digite aqui sua observação..."
											className="resize-y"
										/>
									</FormControl>
								</FormItem>
							)}
						/>
						<Button
							type="submit"
							className="mt-2"
							onClick={form.handleSubmit(handleSaveSchedule)}
						>
							Agendar
						</Button>
					</form>
				</Form>
			</DialogContent>
		</Dialog>
	)
}
